import axios, { type AxiosRequestConfig } from 'axios'

import { createHttpResponseErrorHandler } from '@/network'
import { resolveAuthTokenRaw } from '@/stores/auth-utils'

function getCosHttpBaseUrl(): string {
  return String(import.meta.env.VITE_GO_API_BASE_URL ?? '').trim().replace(/\/+$/, '')
}

export function hasDedicatedCosCredentialBase(): boolean {
  return getCosHttpBaseUrl().length > 0
}

const instance = axios.create({
  baseURL: getCosHttpBaseUrl(),
  timeout: 15_000,
  headers: {
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use(
  config => {
    const base = getCosHttpBaseUrl()
    if (base) {
      config.baseURL = base
    }
    const raw = resolveAuthTokenRaw()
    if (raw) {
      const v = /^bearer\s+/i.test(raw) ? raw : `Bearer ${raw}`
      try {
        config.headers.set('Authorization', v)
      } catch {
        ;(config.headers as Record<string, string>)['Authorization'] = v
      }
      // 与 holoview-test 一致：部分网关只认小写头
      try {
        config.headers.set('authorization', v)
      } catch {
        ;(config.headers as Record<string, string>)['authorization'] = v
      }
    }
    return config
  },
  error => Promise.reject(error),
)

instance.interceptors.response.use(
  response => response.data,
  createHttpResponseErrorHandler({
    showToast: true,
    respectSkipGlobalErrorHandler: true,
  }),
)

export type CosHttpRequestConfig = AxiosRequestConfig & {
  /** 为 true 时不弹全局 message（用于后台预拉取，避免刷屏） */
  skipGlobalErrorHandler?: boolean
}

export const cosHttp = {
  get<T>(url: string, config?: CosHttpRequestConfig): Promise<T> {
    return instance.get(url, config) as Promise<T>
  },
  post<T>(url: string, data?: unknown, config?: CosHttpRequestConfig): Promise<T> {
    return instance.post(url, data, config) as Promise<T>
  },
}
